<template>
  <div class="ai-agent-target">
    <a class="trigger-icon" @click="trigger">
      <svg
        width="18"
        height="18"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M8 17.75h8m3.5-5.5h.75a1.5 1.5 0 0 1 1.5 1.5v2a1.5 1.5 0 0 1-1.5 1.5h-.75m-15-5h-.75a1.5 1.5 0 0 0-1.5 1.5v2a1.5 1.5 0 0 0 1.5 1.5h.75M12 8V6m1.5-1.5A1.5 1.5 0 0 1 12 6a1.5 1.5 0 0 1-1.5-1.5A1.5 1.5 0 0 1 12 3a1.5 1.5 0 0 1 1.5 1.5m2.75 8.75a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5m-5.5 0a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5M8.25 8.5h7.5a3.74 3.74 0 0 1 3.75 3.75v5A3.74 3.74 0 0 1 15.75 21h-7.5a3.74 3.74 0 0 1-3.75-3.75v-5A3.74 3.74 0 0 1 8.25 8.5"
        />
      </svg>
    </a>
    <slot v-if="isOpen">
      <div class="executions" v-if="!showRuleBuilder">
        <div class="title">
          <div>
            <svg
              width="20"
              height="20"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <path
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M8 17.75h8m3.5-5.5h.75a1.5 1.5 0 0 1 1.5 1.5v2a1.5 1.5 0 0 1-1.5 1.5h-.75m-15-5h-.75a1.5 1.5 0 0 0-1.5 1.5v2a1.5 1.5 0 0 0 1.5 1.5h.75M12 8V6m1.5-1.5A1.5 1.5 0 0 1 12 6a1.5 1.5 0 0 1-1.5-1.5A1.5 1.5 0 0 1 12 3a1.5 1.5 0 0 1 1.5 1.5m2.75 8.75a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5m-5.5 0a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5M8.25 8.5h7.5a3.74 3.74 0 0 1 3.75 3.75v5A3.74 3.74 0 0 1 15.75 21h-7.5a3.74 3.74 0 0 1-3.75-3.75v-5A3.74 3.74 0 0 1 8.25 8.5"
              />
            </svg>
            Agent Workflows
          </div>
          <a class="el-icon-close" @click="trigger" />
        </div>
        <div class="workflows">
          <div
            v-for="item in executions"
            :key="item.workflow.id"
            class="workflow"
          >
            <div class="header">
              {{ item.workflow.name }}
              <div class="flex items-center">
                <div
                  v-if="item.execution?.timestamp"
                  class="btn btn-xs btn-default"
                >
                  {{ item.execution.timestamp }}
                </div>
                <a
                  v-if="isSuperAdmin"
                  @click="startConversation(item)"
                  class="btn btn-xs btn-default"
                >
                  <i class="el-icon-chat-line-round" />
                </a>
              </div>
            </div>
            <div class="details">
              <div
                v-if="item.execution?.output_html"
                v-html="item.execution.output_html"
                class="h-full"
              />
              <el-alert
                v-else-if="item.execution?.error"
                :title="item.execution.error"
                type="error"
                :closable="false"
                show-icon
              />
            </div>
          </div>
        </div>
      </div>
      <div class="rule-builder v--modal" v-if="showRuleBuilder">
        <AiAgentRules :execution="selectedExecution" @close="closeRules" />
      </div>
    </slot>
  </div>
</template>
<script>
import AiAgentRules from "@/default/pages/ai/agent/rules.vue";

export default {
  name: "AiAgentTarget",
  components: {
    AiAgentRules,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
      executions: [],
      showRuleBuilder: false,
      selectedExecution: {},
    };
  },
  methods: {
    async trigger() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        await this.loadTarget();
      }
    },
    async loadTarget() {
      try {
        const response = await this.$http2.get(
          `/api/v1/agent_executions/target`,
          {
            params: {
              type: this.type,
              id: this.id,
            },
          }
        );
        this.executions = response.data;
      } catch (err) {}
    },
    async startConversation(item) {
      try {
        await this.$confirm(
          "Are you sure to start conversation to build the rules?",
          "Confirmation",
          {
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            type: "warning",
          }
        );
        this.selectedExecution = {
          id: item.execution.id,
          workflow_id: item.workflow.id,
        };
        this.showRuleBuilder = true;
      } catch (err) {}
    },
    async closeRules() {
      this.showRuleBuilder = false;
      this.selectedExecution = {};
      await this.loadTarget();
    },
  },
};
</script>
<style lang="scss" scoped>
.ai-agent-target {
  .trigger-icon {
    @apply border border-blue-500 rounded size-5 flex items-center justify-center;
    svg {
      @apply -mt-0.5;
    }
  }
  .executions {
    @apply w-[960px] max-h-96 flex flex-col bg-white fixed right-1 bottom-1 border rounded;
    .title {
      @apply bg-slate-50 p-2 font-bold text-xs text-gray-600 border-b flex items-center justify-between;
    }
    .workflows {
      @apply grow overflow-auto flex flex-col gap-2 flex-1 overflow-y-auto m-2;
      .workflow {
        @apply border rounded bg-white;
        .header {
          @apply flex items-center justify-between border-b text-xs p-1.5 bg-slate-50 h-8;
        }
        .details {
          @apply p-1;
        }
      }
    }
  }
  .rule-builder {
    @apply w-[960px] h-4/5 bg-white fixed right-1 bottom-1 border rounded;
  }
}
</style>
